import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "users" };
import bus from '@/helpers/events/bus';
// components
import UsersList from '@/components/settings/users/UsersList.vue';
import UserCreateEdit from '@/components/settings/users/UserCreateEdit.vue';
// utilities
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { onMounted, reactive, ref } from 'vue';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Users',
    setup(__props) {
        // libs, helpers, services
        const mode = ref('');
        const userSelected = reactive({
            id: '',
            name: '',
            email: '',
            client: null,
            brands: [],
            profile: null,
            enabled: '',
            routes: '',
            user_360: null,
            dataComplete: false,
        });
        function openCreate() {
            mode.value = 'create';
            useMixpanelConfig('settings-users_clicked_btn-open-create');
            router.push('/settings/users/create');
            bus.$emit('user-create-open');
        }
        function clearUserSelected() {
            userSelected.id = '';
            userSelected.name = '';
            userSelected.email = '';
            userSelected.client = null;
            userSelected.brands = [];
            userSelected.profile = null;
            userSelected.enabled = '';
            userSelected.routes = '';
            userSelected.user_360 = null;
            userSelected.dataComplete = false;
        }
        function openEdit(user) {
            mode.value = 'edit';
            userSelected.id = user?.id;
            userSelected.name = user?.name;
            userSelected.email = user?.email;
            userSelected.client = {
                clientId: user.client?.clientId,
                name: user.client?.name,
                id: user.client?.id,
                stores: user.client?.stores,
                hasMultipleAccounts: user.client?.hasMultipleAccounts,
            };
            userSelected.brands = user.brands.map(brand => brand);
            userSelected.profile = {
                id: user.profile?.id,
                name: user.profile?.name,
                description: user.profile?.description,
            };
            userSelected.enabled = user?.enabled;
            userSelected.routes = user?.routes;
            userSelected.user_360 = user?.user360;
            router.push(`/settings/users/edit/${user.id}`);
            useMixpanelConfig('settings-users_clicked_btn-open-edit');
            bus.$emit('user-edit-open');
        }
        onMounted(() => {
            useMixpanelConfig('settings-users_viewed');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(UsersList, {
                    onOpenCreate: openCreate,
                    onOpenEdit: openEdit
                }),
                _createVNode(UserCreateEdit, {
                    mode: mode.value,
                    "reset-fields": clearUserSelected,
                    "user-selected": userSelected
                }, null, 8, ["mode", "user-selected"])
            ]));
        };
    }
});
